<template>
  <div class="newhome">
    <div class="lang" v-for="(item,index) in langList" :key="{index}" @click="handleClickLang(item)">
      {{ item }}
    </div>
    <p>{{ this.$i18n.locale }}</p>
    <p>{{ $t('message.strid46') }}</p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["_initdata"])
  },
  data() {
    return {
      langList: ["en", "es"],
      regionIndex: 100
    };
  },
  methods: {
    handleClickLang(e) {
      console.log(e);
      localStorage.setItem('lang', e)
      this.$i18n.locale = e
    },
    choseRegion(e) {
      this.regionIndex = e.target.dataset.index;
    }
  }
};
</script>

<style lang="scss">
@media screen and (max-width: $maxViewWidth) {
  @import "@/assets/scss/views/m/home.scss";
}
</style>
